<template>
  <div class="login-page">
    <div class="left-section">
      <h1 class="system-title">鼎磊安保考勤系统</h1>
    </div>
    <div class="right-section">
      <div class="login-box">
        <el-form
          ref="loginForm"
          :rules="formRules"
          :model="loginUser"
          label-width="80px"
        >
          <h2 class="login-title">登录</h2>
          <el-form-item label="账号" prop="userName">
            <el-input
              prefix-icon="el-icon-user"
              type="text"
              v-model="loginUser.userName"
              placeholder="请输入账号"
              :maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              prefix-icon="el-icon-lock"
              type="password"
              v-model="loginUser.password"
              placeholder="请输入密码"
              :maxlength="50"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="loginBtn"
              @click="handleLogin"
              class="login-button"
            >
              登陆
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="footer">
      <a href="https://beian.miit.gov.cn/" target="_blank" class="link">备案号:苏ICP备2023016829号-2</a><br/>
      <a href="https://beian.mps.gov.cn/#/query/webSearch" target="_blank" class="link">苏公网安备2023016829号</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  data() {
    return {
      loginUser: {
        userName: '',
        password: '',
      },
      formRules: {
        userName: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
        password: [
          { required: true, message: '密码不能为空', trigger: 'blur' },
        ],
      },
      loginBtn: false,
    };
  },
  methods: {
    handleLogin() {
      this.$refs['loginForm'].validate((valid) => {
        if (valid) {
          this.loginBtn = true;
          this.$api.login({
            params: this.loginUser,
            success: (res) => {
              const { token } = res.data;
              localStorage.setItem('clock_in_token', token);
              this.$router.push({ path: '/' });
            },
            complete: (res) => {
              this.loginBtn = false;
            },
          });
        }
      });
    },
    resetForm() {
      this.$refs['loginForm'].resetFields();
    },
  },
};
</script>

<style scoped>
.login-page {
  display: flex;
  height: 100vh;
  background: linear-gradient(to right, #4a90e2, #f0f2f5);
}

.left-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}

.system-title {
  font-size: 48px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.right-section {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.login-box {
  width: 400px;
  padding: 40px;
  background-color: transparent;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.login-title {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: center;
}

.login-button {
  display: block;
  width: 100%;
  margin: 0 auto;
}

.footer {
  position: fixed;
  bottom: 20px;
  width: 100%;
  text-align: center;
  font-size: 14px;
}

.link {
  margin: 0 10px;
  text-decoration: none;
  color: #a5a7b4;
}
</style>
